































































































import Vue, { PropType } from 'vue';
import {
  ExhibitorData,
  ExhibitorCompanyData as CompanyData,
} from 'mostra';

interface DataType {
  descriptionTexts: object;
}

interface DescriptionTexts {
  image: string[],
}

const descriptionTexts: DescriptionTexts = {
  image: [
    'バイヤーから問い合わせがあった際のチャットのやり取りなどで使います。',
  ],
};

export default Vue.extend({
  name: 'GAccountPersonInCharge',
  props: {
    owner: {
      type: String as PropType<string>,
      required: true,
    },
    company: {
      type: Object as PropType<CompanyData>,
      default: () => ({}),
    },
    exhibitor: {
      type: Object as PropType<ExhibitorData>,
      default: () => ({}),
    },
  },
  data(): DataType {
    return {
      descriptionTexts: descriptionTexts,
    };
  },
});
